import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { dashApi } from "@/lib/dashApi";
import { EmptyState, ErrorState, LoadingState, PageHeader, Panel, SourceBadge, TrustPill } from "@/components/dash/ui";

export default function KpiQualityPage() {
  const q = useQuery({ queryKey: ["trust-kpis"], queryFn: dashApi.trustKpis });
  const [label, setLabel] = useState("all");
  const rows = (q.data?.kpis ?? []).filter((k) => label === "all" || k.label === label);
  const labels = ["all", ...Object.keys(q.data?.summary ?? {})];

  return (
    <div className="space-y-6">
      <PageHeader
        title="KPI Quality"
        description="Which KPIs are complete, partial, stale or insufficient — derived from source health and warehouse coverage. A KPI is only 'trusted' when its source is healthy and the warehouse has fresh rows."
        right={
          <select value={label} onChange={(e) => setLabel(e.target.value)} className="rounded-lg border border-ink-500/60 bg-ink-800 px-2.5 py-1.5 text-xs text-slate-200 [color-scheme:dark]">
            {labels.map((l) => <option key={l} value={l}>{l === "all" ? "All trust labels" : l}</option>)}
          </select>
        }
      />
      <Panel title={`KPIs (${rows.length})`}>
        {q.isLoading ? <LoadingState /> : q.isError ? <ErrorState error={q.error} /> : !rows.length ? (
          <EmptyState>No KPIs match this filter.</EmptyState>
        ) : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-[11px] uppercase tracking-wide text-slate-500">
              <th className="pb-2 font-medium">KPI</th><th className="pb-2 font-medium">Source</th>
              <th className="pb-2 font-medium">Trust</th><th className="pb-2 text-right font-medium">Coverage (7d)</th>
              <th className="pb-2 font-medium">Reason</th>
            </tr></thead>
            <tbody className="divide-y divide-ink-500/40">
              {rows.map((k) => (
                <tr key={k.kpi} className="text-slate-300">
                  <td className="py-2"><span className="text-slate-100">{k.label_text}</span><div className="text-[11px] text-slate-600">{k.kpi}</div></td>
                  <td className="py-2"><SourceBadge code={k.source} /></td>
                  <td className="py-2"><TrustPill label={k.label} /></td>
                  <td className="py-2 text-right tabular-nums text-slate-400">{k.coverage_days}d</td>
                  <td className="py-2 text-xs text-slate-400">{k.reason}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Panel>
    </div>
  );
}
